import { render, staticRenderFns } from "./SideBarBaseModal.vue?vue&type=template&id=53e718f0&"
import script from "./SideBarBaseModal.vue?vue&type=script&lang=ts&"
export * from "./SideBarBaseModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports